import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule }    from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClientModule } from '@angular/common/http';

// Firebase データベース
import { environment } from '../environments/environment';
import { AngularFireModule } from '@angular/fire';
import { AngularFirestore } from '@angular/fire/firestore';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { AngularFireAuthModule } from '@angular/fire/auth'; 
import { FirebaseUIModule, firebase, firebaseui } from 'firebaseui-angular';

// Kano 自分のモジュール
import { DblistComponent } from './dblist/dblist.component';
import { FileuploadComponent } from './fileupload/fileupload.component';
import { SendemailService } from './sendemail.service';

//import { FileUploadModule } from 'primeng/fileupload';
import { FileUploadModule } from 'primeng/components/fileupload/fileupload'; // PrimeNG
//import { MatPaginatorModule } from '@angular/material/paginator';

// FirebaseUI初期化コード
const firebaseUiAuthConfig: firebaseui.auth.Config = {
   autoUpgradeAnonymousUsers: false, // 匿名認証ユーザー自動アップグレード
   signInFlow: 'popup', // redirect or popup
   signInSuccessUrl: '/',
   credentialHelper: firebaseui.auth.CredentialHelper.NONE,
   signInOptions: [
    {
      provider: firebase.auth.EmailAuthProvider.PROVIDER_ID,
      //signInMethod: firebase.auth.EmailAuthProvider.EMAIL_LINK_SIGN_IN_METHOD,
      //requireDisplayName: false, //ユーザ名を強要するか
      //forceSameDevice: false, //同じモバイルであることを強制するか
   },
     firebase.auth.GoogleAuthProvider.PROVIDER_ID,
     //firebase.auth.FacebookAuthProvider.PROVIDER_ID,
     firebase.auth.TwitterAuthProvider.PROVIDER_ID,
     firebase.auth.PhoneAuthProvider.PROVIDER_ID,
     //匿名ログインは無効にする
     //firebaseui.auth.AnonymousAuthProvider.PROVIDER_ID
   ],
};

@NgModule({
   declarations: [
      AppComponent,
      DblistComponent,
      FileuploadComponent,
   ],
   imports: [
      BrowserModule,
      BrowserAnimationsModule,
      AppRoutingModule,
      FormsModule,
      ReactiveFormsModule,
      AngularFireModule.initializeApp(environment.firebase),
      AngularFirestoreModule,
      AngularFireAuthModule,
      FirebaseUIModule.forRoot(firebaseUiAuthConfig),
      FileUploadModule,
      HttpClientModule,
      //MatPaginatorModule,
   ],
   providers: [
      AngularFirestore,
      SendemailService,
   ],
   bootstrap: [
      AppComponent,
   ]
})

export class AppModule { }
